import { useObservable } from "hooks";
import { detailService } from "services";

const useSearchWeb = () => [
  useObservable(detailService.web$),
  detailService.web,
];

export { useSearchWeb };
